export const N5_KANJI_MASSIVE = [
  {
    "kanji": "一",
    "onyomi": "イチ, イツ",
    "kunyomi": "ひと-, ひと.つ",
    "meaning": "one",
    "bn": "এক",
    "level": "N5",
    "strokes": 1,
    "examples": [
      {
        "word": "一人",
        "reading": "ひとり",
        "meaning": "one person"
      }
    ]
  },
  {
    "kanji": "二",
    "onyomi": "ニ, ジ",
    "kunyomi": "ふた-, ふた.つ",
    "meaning": "two",
    "bn": "দুই",
    "level": "N5",
    "strokes": 2,
    "examples": [
      {
        "word": "二人",
        "reading": "ふたり",
        "meaning": "two people"
      }
    ]
  },
  {
    "kanji": "三",
    "onyomi": "サン",
    "kunyomi": "み-, み.つ",
    "meaning": "three",
    "bn": "তিন",
    "level": "N5",
    "strokes": 3,
    "examples": [
      {
        "word": "三月",
        "reading": "さんがつ",
        "meaning": "March"
      }
    ]
  },
  {
    "kanji": "四",
    "onyomi": "シ",
    "kunyomi": "よ-, よ.つ, よん",
    "meaning": "four",
    "bn": "চার",
    "level": "N5",
    "strokes": 5,
    "examples": [
      {
        "word": "四月",
        "reading": "しがつ",
        "meaning": "April"
      }
    ]
  },
  {
    "kanji": "五",
    "onyomi": "ゴ",
    "kunyomi": "いつ-, いつ.つ",
    "meaning": "five",
    "bn": "পাঁচ",
    "level": "N5",
    "strokes": 4,
    "examples": [
      {
        "word": "五月",
        "reading": "ごがつ",
        "meaning": "May"
      }
    ]
  },
  {
    "kanji": "六",
    "onyomi": "ロク",
    "kunyomi": "む-, む.つ",
    "meaning": "six",
    "bn": "ছয়",
    "level": "N5",
    "strokes": 4,
    "examples": [
      {
        "word": "六月",
        "reading": "ろくがつ",
        "meaning": "June"
      }
    ]
  },
  {
    "kanji": "七",
    "onyomi": "シチ",
    "kunyomi": "なな-, なな.つ",
    "meaning": "seven",
    "bn": "সাত",
    "level": "N5",
    "strokes": 2,
    "examples": [
      {
        "word": "七月",
        "reading": "しちがつ",
        "meaning": "July"
      }
    ]
  },
  {
    "kanji": "八",
    "onyomi": "ハチ",
    "kunyomi": "や-, や.つ",
    "meaning": "eight",
    "bn": "আট",
    "level": "N5",
    "strokes": 2,
    "examples": [
      {
        "word": "八月",
        "reading": "はちがつ",
        "meaning": "August"
      }
    ]
  },
  {
    "kanji": "九",
    "onyomi": "キュウ, ク",
    "kunyomi": "ここの-, ここの.つ",
    "meaning": "nine",
    "bn": "নয়",
    "level": "N5",
    "strokes": 2,
    "examples": [
      {
        "word": "九月",
        "reading": "くがつ",
        "meaning": "September"
      }
    ]
  },
  {
    "kanji": "十",
    "onyomi": "ジュウ, ジッ",
    "kunyomi": "とお, と",
    "meaning": "ten",
    "bn": "দশ",
    "level": "N5",
    "strokes": 2,
    "examples": [
      {
        "word": "十月",
        "reading": "じゅうがつ",
        "meaning": "October"
      }
    ]
  },
  {
    "kanji": "百",
    "onyomi": "ヒャク, ビャク",
    "kunyomi": "",
    "meaning": "hundred",
    "bn": "একশ",
    "level": "N5",
    "strokes": 6,
    "examples": [
      {
        "word": "百円",
        "reading": "ひゃくえん",
        "meaning": "100 yen"
      }
    ]
  },
  {
    "kanji": "千",
    "onyomi": "セン",
    "kunyomi": "ち",
    "meaning": "thousand",
    "bn": "হাজার",
    "level": "N5",
    "strokes": 3,
    "examples": [
      {
        "word": "千円",
        "reading": "せんえん",
        "meaning": "1000 yen"
      }
    ]
  },
  {
    "kanji": "万",
    "onyomi": "マン, バン",
    "kunyomi": "",
    "meaning": "ten thousand",
    "bn": "দশ হাজার",
    "level": "N5",
    "strokes": 3,
    "examples": [
      {
        "word": "一万",
        "reading": "いちまん",
        "meaning": "10,000"
      }
    ]
  },
  {
    "kanji": "円",
    "onyomi": "エン",
    "kunyomi": "まる-",
    "meaning": "yen, circle",
    "bn": "ইয়েন, বৃত্ত",
    "level": "N5",
    "strokes": 4,
    "examples": [
      {
        "word": "円い",
        "reading": "まるい",
        "meaning": "round"
      }
    ]
  },
  {
    "kanji": "年",
    "onyomi": "ネン",
    "kunyomi": "とし",
    "meaning": "year",
    "bn": "বছর",
    "level": "N5",
    "strokes": 6,
    "examples": [
      {
        "word": "今年",
        "reading": "ことし",
        "meaning": "this year"
      }
    ]
  },
  {
    "kanji": "月",
    "onyomi": "ゲツ, ガツ",
    "kunyomi": "つき",
    "meaning": "month, moon",
    "bn": "মাস, চাঁদ",
    "level": "N5",
    "strokes": 4,
    "examples": [
      {
        "word": "今月",
        "reading": "こんげつ",
        "meaning": "this month"
      }
    ]
  },
  {
    "kanji": "日",
    "onyomi": "ニチ, ジツ",
    "kunyomi": "ひ, か",
    "meaning": "day, sun",
    "bn": "দিন, সূর্য",
    "level": "N5",
    "strokes": 4,
    "examples": [
      {
        "word": "今日",
        "reading": "きょう",
        "meaning": "today"
      }
    ]
  },
  {
    "kanji": "週",
    "onyomi": "シュウ",
    "kunyomi": "",
    "meaning": "week",
    "bn": "সপ্তাহ",
    "level": "N5",
    "strokes": 11,
    "examples": [
      {
        "word": "今週",
        "reading": "こんしゅう",
        "meaning": "this week"
      }
    ]
  },
  {
    "kanji": "時",
    "onyomi": "ジ",
    "kunyomi": "とき",
    "meaning": "time, hour",
    "bn": "সময়, ঘণ্টা",
    "level": "N5",
    "strokes": 10,
    "examples": [
      {
        "word": "時間",
        "reading": "じかん",
        "meaning": "time/hour"
      }
    ]
  },
  {
    "kanji": "分",
    "onyomi": "ブン, フン",
    "kunyomi": "わ.ける",
    "meaning": "minute, part",
    "bn": "মিনিট, অংশ",
    "level": "N5",
    "strokes": 4,
    "examples": [
      {
        "word": "五分",
        "reading": "ごふん",
        "meaning": "5 minutes"
      }
    ]
  },
  {
    "kanji": "半",
    "onyomi": "ハン",
    "kunyomi": "なか.ば",
    "meaning": "half",
    "bn": "অর্ধেক",
    "level": "N5",
    "strokes": 5,
    "examples": [
      {
        "word": "半分",
        "reading": "はんぶん",
        "meaning": "half"
      }
    ]
  },
  {
    "kanji": "今",
    "onyomi": "コン, キン",
    "kunyomi": "いま",
    "meaning": "now",
    "bn": "এখন",
    "level": "N5",
    "strokes": 4,
    "examples": [
      {
        "word": "今日",
        "reading": "きょう",
        "meaning": "today"
      }
    ]
  },
  {
    "kanji": "何",
    "onyomi": "カ",
    "kunyomi": "なに, なん",
    "meaning": "what",
    "bn": "কী",
    "level": "N5",
    "strokes": 7,
    "examples": [
      {
        "word": "何人",
        "reading": "なんにん",
        "meaning": "how many people"
      }
    ]
  },
  {
    "kanji": "人",
    "onyomi": "ジン, ニン",
    "kunyomi": "ひと",
    "meaning": "person",
    "bn": "ব্যক্তি",
    "level": "N5",
    "strokes": 2,
    "examples": [
      {
        "word": "日本人",
        "reading": "にほんじん",
        "meaning": "Japanese person"
      }
    ]
  },
  {
    "kanji": "男",
    "onyomi": "ダン, ナン",
    "kunyomi": "おとこ",
    "meaning": "man, male",
    "bn": "পুরুষ",
    "level": "N5",
    "strokes": 7,
    "examples": [
      {
        "word": "男の子",
        "reading": "おとこのこ",
        "meaning": "boy"
      }
    ]
  },
  {
    "kanji": "女",
    "onyomi": "ジョ, ニョ",
    "kunyomi": "おんな",
    "meaning": "woman, female",
    "bn": "মহিলা",
    "level": "N5",
    "strokes": 3,
    "examples": [
      {
        "word": "女の子",
        "reading": "おんなのこ",
        "meaning": "girl"
      }
    ]
  },
  {
    "kanji": "子",
    "onyomi": "シ, ス",
    "kunyomi": "こ",
    "meaning": "child",
    "bn": "শিশু",
    "level": "N5",
    "strokes": 3,
    "examples": [
      {
        "word": "子供",
        "reading": "こども",
        "meaning": "child"
      }
    ]
  },
  {
    "kanji": "父",
    "onyomi": "フ",
    "kunyomi": "ちち",
    "meaning": "father",
    "bn": "বাবা",
    "level": "N5",
    "strokes": 4,
    "examples": [
      {
        "word": "お父さん",
        "reading": "おとうさん",
        "meaning": "father (polite)"
      }
    ]
  },
  {
    "kanji": "母",
    "onyomi": "ボ",
    "kunyomi": "はは",
    "meaning": "mother",
    "bn": "মা",
    "level": "N5",
    "strokes": 5,
    "examples": [
      {
        "word": "お母さん",
        "reading": "おかあさん",
        "meaning": "mother (polite)"
      }
    ]
  },
  {
    "kanji": "友",
    "onyomi": "ユウ",
    "kunyomi": "とも",
    "meaning": "friend",
    "bn": "বন্ধু",
    "level": "N5",
    "strokes": 4,
    "examples": [
      {
        "word": "友達",
        "reading": "ともだち",
        "meaning": "friend"
      }
    ]
  },
  {
    "kanji": "先",
    "onyomi": "セン",
    "kunyomi": "さき",
    "meaning": "before, previous",
    "bn": "আগে",
    "level": "N5",
    "strokes": 6,
    "examples": [
      {
        "word": "先生",
        "reading": "せんせい",
        "meaning": "teacher"
      }
    ]
  },
  {
    "kanji": "生",
    "onyomi": "セイ, ショウ",
    "kunyomi": "い.きる, う.まれる",
    "meaning": "life, birth",
    "bn": "জীবন",
    "level": "N5",
    "strokes": 5,
    "examples": [
      {
        "word": "学生",
        "reading": "がくせい",
        "meaning": "student"
      }
    ]
  },
  {
    "kanji": "学",
    "onyomi": "ガク",
    "kunyomi": "まな.ぶ",
    "meaning": "study, learning",
    "bn": "শিক্ষা",
    "level": "N5",
    "strokes": 8,
    "examples": [
      {
        "word": "大学",
        "reading": "だいがく",
        "meaning": "university"
      }
    ]
  },
  {
    "kanji": "校",
    "onyomi": "コウ",
    "kunyomi": "",
    "meaning": "school",
    "bn": "বিদ্যালয়",
    "level": "N5",
    "strokes": 10,
    "examples": [
      {
        "word": "学校",
        "reading": "がっこう",
        "meaning": "school"
      }
    ]
  },
  {
    "kanji": "大",
    "onyomi": "ダイ, タイ",
    "kunyomi": "おお-, おお.きい",
    "meaning": "big, large",
    "bn": "বড়",
    "level": "N5",
    "strokes": 3,
    "examples": [
      {
        "word": "大きい",
        "reading": "おおきい",
        "meaning": "big"
      }
    ]
  },
  {
    "kanji": "小",
    "onyomi": "ショウ",
    "kunyomi": "ちい.さい, こ-",
    "meaning": "small, little",
    "bn": "ছোট",
    "level": "N5",
    "strokes": 3,
    "examples": [
      {
        "word": "小さい",
        "reading": "ちいさい",
        "meaning": "small"
      }
    ]
  },
  {
    "kanji": "中",
    "onyomi": "チュウ",
    "kunyomi": "なか",
    "meaning": "middle, inside",
    "bn": "মাঝখানে",
    "level": "N5",
    "strokes": 4,
    "examples": [
      {
        "word": "中国",
        "reading": "ちゅうごく",
        "meaning": "China"
      }
    ]
  },
  {
    "kanji": "上",
    "onyomi": "ジョウ",
    "kunyomi": "うえ, あ.げる, のぼ.る",
    "meaning": "up, above",
    "bn": "উপরে",
    "level": "N5",
    "strokes": 3,
    "examples": [
      {
        "word": "上手",
        "reading": "じょうず",
        "meaning": "skillful"
      }
    ]
  },
  {
    "kanji": "下",
    "onyomi": "カ, ゲ",
    "kunyomi": "した, さ.げる, くだ.る",
    "meaning": "down, below",
    "bn": "নিচে",
    "level": "N5",
    "strokes": 3,
    "examples": [
      {
        "word": "下手",
        "reading": "へた",
        "meaning": "unskillful"
      }
    ]
  },
  {
    "kanji": "左",
    "onyomi": "サ",
    "kunyomi": "ひだり",
    "meaning": "left",
    "bn": "বাম",
    "level": "N5",
    "strokes": 5,
    "examples": [
      {
        "word": "左手",
        "reading": "ひだりて",
        "meaning": "left hand"
      }
    ]
  },
  {
    "kanji": "右",
    "onyomi": "ウ, ユウ",
    "kunyomi": "みぎ",
    "meaning": "right",
    "bn": "ডান",
    "level": "N5",
    "strokes": 5,
    "examples": [
      {
        "word": "右手",
        "reading": "みぎて",
        "meaning": "right hand"
      }
    ]
  },
  {
    "kanji": "前",
    "onyomi": "ゼン",
    "kunyomi": "まえ",
    "meaning": "front, before",
    "bn": "সামনে",
    "level": "N5",
    "strokes": 9,
    "examples": [
      {
        "word": "名前",
        "reading": "なまえ",
        "meaning": "name"
      }
    ]
  },
  {
    "kanji": "後",
    "onyomi": "ゴ, コウ",
    "kunyomi": "あと, うし.ろ",
    "meaning": "back, after",
    "bn": "পেছনে",
    "level": "N5",
    "strokes": 9,
    "examples": [
      {
        "word": "午後",
        "reading": "ごご",
        "meaning": "afternoon"
      }
    ]
  },
  {
    "kanji": "外",
    "onyomi": "ガイ, ゲ",
    "kunyomi": "そと, ほか",
    "meaning": "outside",
    "bn": "বাইরে",
    "level": "N5",
    "strokes": 5,
    "examples": [
      {
        "word": "外国",
        "reading": "がいこく",
        "meaning": "foreign country"
      }
    ]
  },
  {
    "kanji": "国",
    "onyomi": "コク",
    "kunyomi": "くに",
    "meaning": "country",
    "bn": "দেশ",
    "level": "N5",
    "strokes": 8,
    "examples": [
      {
        "word": "日本",
        "reading": "にほん",
        "meaning": "Japan"
      }
    ]
  },
  {
    "kanji": "本",
    "onyomi": "ホン",
    "kunyomi": "もと",
    "meaning": "book, origin",
    "bn": "বই",
    "level": "N5",
    "strokes": 5,
    "examples": [
      {
        "word": "日本",
        "reading": "にほん",
        "meaning": "Japan"
      }
    ]
  },
  {
    "kanji": "語",
    "onyomi": "ゴ",
    "kunyomi": "かた.る",
    "meaning": "language, word",
    "bn": "ভাষা",
    "level": "N5",
    "strokes": 14,
    "examples": [
      {
        "word": "日本語",
        "reading": "にほんご",
        "meaning": "Japanese language"
      }
    ]
  },
  {
    "kanji": "話",
    "onyomi": "ワ",
    "kunyomi": "はな.す, はなし",
    "meaning": "speak, talk",
    "bn": "কথা বলা",
    "level": "N5",
    "strokes": 13,
    "examples": [
      {
        "word": "電話",
        "reading": "でんわ",
        "meaning": "telephone"
      }
    ]
  },
  {
    "kanji": "聞",
    "onyomi": "ブン, モン",
    "kunyomi": "き.く",
    "meaning": "hear, listen",
    "bn": "শোনা",
    "level": "N5",
    "strokes": 14,
    "examples": [
      {
        "word": "新聞",
        "reading": "しんぶん",
        "meaning": "newspaper"
      }
    ]
  },
  {
    "kanji": "読",
    "onyomi": "ドク, トク",
    "kunyomi": "よ.む",
    "meaning": "read",
    "bn": "পড়া",
    "level": "N5",
    "strokes": 14,
    "examples": [
      {
        "word": "読書",
        "reading": "どくしょ",
        "meaning": "reading"
      }
    ]
  },
  {
    "kanji": "書",
    "onyomi": "ショ",
    "kunyomi": "か.く",
    "meaning": "write",
    "bn": "লেখা",
    "level": "N5",
    "strokes": 10,
    "examples": [
      {
        "word": "辞書",
        "reading": "じしょ",
        "meaning": "dictionary"
      }
    ]
  },
  {
    "kanji": "見",
    "onyomi": "ケン",
    "kunyomi": "み.る, み.える",
    "meaning": "see, look",
    "bn": "দেখা",
    "level": "N5",
    "strokes": 7,
    "examples": [
      {
        "word": "見物",
        "reading": "けんぶつ",
        "meaning": "sightseeing"
      }
    ]
  },
  {
    "kanji": "行",
    "onyomi": "コウ, ギョウ",
    "kunyomi": "い.く, おこな.う",
    "meaning": "go",
    "bn": "যাওয়া",
    "level": "N5",
    "strokes": 6,
    "examples": [
      {
        "word": "旅行",
        "reading": "りょこう",
        "meaning": "travel"
      }
    ]
  },
  {
    "kanji": "来",
    "onyomi": "ライ",
    "kunyomi": "く.る, きた.る",
    "meaning": "come",
    "bn": "আসা",
    "level": "N5",
    "strokes": 7,
    "examples": [
      {
        "word": "来月",
        "reading": "らいげつ",
        "meaning": "next month"
      }
    ]
  },
  {
    "kanji": "出",
    "onyomi": "シュツ, スイ",
    "kunyomi": "で.る, だ.す",
    "meaning": "exit, go out",
    "bn": "বের হওয়া",
    "level": "N5",
    "strokes": 5,
    "examples": [
      {
        "word": "出口",
        "reading": "でぐち",
        "meaning": "exit"
      }
    ]
  },
  {
    "kanji": "入",
    "onyomi": "ニュウ",
    "kunyomi": "い.る, はい.る",
    "meaning": "enter",
    "bn": "প্রবেশ করা",
    "level": "N5",
    "strokes": 2,
    "examples": [
      {
        "word": "入口",
        "reading": "いりぐち",
        "meaning": "entrance"
      }
    ]
  },
  {
    "kanji": "食",
    "onyomi": "ショク, ジキ",
    "kunyomi": "た.べる, く.う",
    "meaning": "eat, food",
    "bn": "খাওয়া",
    "level": "N5",
    "strokes": 9,
    "examples": [
      {
        "word": "食べ物",
        "reading": "たべもの",
        "meaning": "food"
      }
    ]
  },
  {
    "kanji": "飲",
    "onyomi": "イン",
    "kunyomi": "の.む",
    "meaning": "drink",
    "bn": "পান করা",
    "level": "N5",
    "strokes": 12,
    "examples": [
      {
        "word": "飲み物",
        "reading": "のみもの",
        "meaning": "drink"
      }
    ]
  },
  {
    "kanji": "買",
    "onyomi": "バイ",
    "kunyomi": "か.う",
    "meaning": "buy",
    "bn": "কেনা",
    "level": "N5",
    "strokes": 12,
    "examples": [
      {
        "word": "買い物",
        "reading": "かいもの",
        "meaning": "shopping"
      }
    ]
  },
  {
    "kanji": "売",
    "onyomi": "バイ",
    "kunyomi": "う.る",
    "meaning": "sell",
    "bn": "বিক্রি করা",
    "level": "N5",
    "strokes": 7,
    "examples": [
      {
        "word": "売店",
        "reading": "ばいてん",
        "meaning": "shop/stand"
      }
    ]
  },
  {
    "kanji": "休",
    "onyomi": "キュウ",
    "kunyomi": "やす.む",
    "meaning": "rest",
    "bn": "বিশ্রাম",
    "level": "N5",
    "strokes": 6,
    "examples": [
      {
        "word": "休日",
        "reading": "きゅうじつ",
        "meaning": "holiday"
      }
    ]
  },
  {
    "kanji": "立",
    "onyomi": "リツ",
    "kunyomi": "た.つ",
    "meaning": "stand",
    "bn": "দাঁড়ানো",
    "level": "N5",
    "strokes": 5,
    "examples": [
      {
        "word": "立派",
        "reading": "りっぱ",
        "meaning": "splendid"
      }
    ]
  },
  {
    "kanji": "会",
    "onyomi": "カイ, エ",
    "kunyomi": "あ.う",
    "meaning": "meet, meeting",
    "bn": "দেখা করা",
    "level": "N5",
    "strokes": 6,
    "examples": [
      {
        "word": "会社",
        "reading": "かいしゃ",
        "meaning": "company"
      }
    ]
  },
  {
    "kanji": "社",
    "onyomi": "シャ",
    "kunyomi": "やしろ",
    "meaning": "company, society",
    "bn": "কোম্পানি",
    "level": "N5",
    "strokes": 7,
    "examples": [
      {
        "word": "神社",
        "reading": "じんじゃ",
        "meaning": "shrine"
      }
    ]
  },
  {
    "kanji": "店",
    "onyomi": "テン",
    "kunyomi": "みせ",
    "meaning": "shop, store",
    "bn": "দোকান",
    "level": "N5",
    "strokes": 8,
    "examples": [
      {
        "word": "喫茶店",
        "reading": "きっさてん",
        "meaning": "café"
      }
    ]
  },
  {
    "kanji": "駅",
    "onyomi": "エキ",
    "kunyomi": "",
    "meaning": "station",
    "bn": "স্টেশন",
    "level": "N5",
    "strokes": 14,
    "examples": [
      {
        "word": "東京駅",
        "reading": "とうきょうえき",
        "meaning": "Tokyo Station"
      }
    ]
  },
  {
    "kanji": "車",
    "onyomi": "シャ",
    "kunyomi": "くるま",
    "meaning": "car, vehicle",
    "bn": "গাড়ি",
    "level": "N5",
    "strokes": 7,
    "examples": [
      {
        "word": "電車",
        "reading": "でんしゃ",
        "meaning": "train"
      }
    ]
  },
  {
    "kanji": "電",
    "onyomi": "デン",
    "kunyomi": "",
    "meaning": "electricity",
    "bn": "বিদ্যুৎ",
    "level": "N5",
    "strokes": 13,
    "examples": [
      {
        "word": "電気",
        "reading": "でんき",
        "meaning": "electricity"
      }
    ]
  },
  {
    "kanji": "気",
    "onyomi": "キ, ケ",
    "kunyomi": "",
    "meaning": "spirit, energy",
    "bn": "শক্তি",
    "level": "N5",
    "strokes": 6,
    "examples": [
      {
        "word": "天気",
        "reading": "てんき",
        "meaning": "weather"
      }
    ]
  },
  {
    "kanji": "天",
    "onyomi": "テン",
    "kunyomi": "あま-, あめ",
    "meaning": "heaven, sky",
    "bn": "আকাশ",
    "level": "N5",
    "strokes": 4,
    "examples": [
      {
        "word": "天気",
        "reading": "てんき",
        "meaning": "weather"
      }
    ]
  },
  {
    "kanji": "雨",
    "onyomi": "ウ",
    "kunyomi": "あめ, あま-",
    "meaning": "rain",
    "bn": "বৃষ্টি",
    "level": "N5",
    "strokes": 8,
    "examples": [
      {
        "word": "大雨",
        "reading": "おおあめ",
        "meaning": "heavy rain"
      }
    ]
  },
  {
    "kanji": "山",
    "onyomi": "サン, セン",
    "kunyomi": "やま",
    "meaning": "mountain",
    "bn": "পাহাড়",
    "level": "N5",
    "strokes": 3,
    "examples": [
      {
        "word": "富士山",
        "reading": "ふじさん",
        "meaning": "Mt. Fuji"
      }
    ]
  },
  {
    "kanji": "川",
    "onyomi": "セン",
    "kunyomi": "かわ",
    "meaning": "river",
    "bn": "নদী",
    "level": "N5",
    "strokes": 3,
    "examples": [
      {
        "word": "川上",
        "reading": "かわかみ",
        "meaning": "upstream"
      }
    ]
  },
  {
    "kanji": "木",
    "onyomi": "モク, ボク",
    "kunyomi": "き, こ-",
    "meaning": "tree, wood",
    "bn": "গাছ",
    "level": "N5",
    "strokes": 4,
    "examples": [
      {
        "word": "木曜日",
        "reading": "もくようび",
        "meaning": "Thursday"
      }
    ]
  },
  {
    "kanji": "花",
    "onyomi": "カ",
    "kunyomi": "はな",
    "meaning": "flower",
    "bn": "ফুল",
    "level": "N5",
    "strokes": 7,
    "examples": [
      {
        "word": "花見",
        "reading": "はなみ",
        "meaning": "flower viewing"
      }
    ]
  },
  {
    "kanji": "火",
    "onyomi": "カ",
    "kunyomi": "ひ",
    "meaning": "fire",
    "bn": "আগুন",
    "level": "N5",
    "strokes": 4,
    "examples": [
      {
        "word": "火曜日",
        "reading": "かようび",
        "meaning": "Tuesday"
      }
    ]
  },
  {
    "kanji": "水",
    "onyomi": "スイ",
    "kunyomi": "みず",
    "meaning": "water",
    "bn": "পানি",
    "level": "N5",
    "strokes": 4,
    "examples": [
      {
        "word": "水曜日",
        "reading": "すいようび",
        "meaning": "Wednesday"
      }
    ]
  },
  {
    "kanji": "金",
    "onyomi": "キン, コン",
    "kunyomi": "かね",
    "meaning": "gold, money",
    "bn": "সোনা, টাকা",
    "level": "N5",
    "strokes": 8,
    "examples": [
      {
        "word": "お金",
        "reading": "おかね",
        "meaning": "money"
      }
    ]
  },
  {
    "kanji": "土",
    "onyomi": "ド, ト",
    "kunyomi": "つち",
    "meaning": "earth, soil",
    "bn": "মাটি",
    "level": "N5",
    "strokes": 3,
    "examples": [
      {
        "word": "土曜日",
        "reading": "どようび",
        "meaning": "Saturday"
      }
    ]
  },
  {
    "kanji": "白",
    "onyomi": "ハク, ビャク",
    "kunyomi": "しろ-, しろ.い",
    "meaning": "white",
    "bn": "সাদা",
    "level": "N5",
    "strokes": 5,
    "examples": [
      {
        "word": "白い",
        "reading": "しろい",
        "meaning": "white"
      }
    ]
  },
  {
    "kanji": "黒",
    "onyomi": "コク",
    "kunyomi": "くろ-, くろ.い",
    "meaning": "black",
    "bn": "কালো",
    "level": "N5",
    "strokes": 11,
    "examples": [
      {
        "word": "黒い",
        "reading": "くろい",
        "meaning": "black"
      }
    ]
  },
  {
    "kanji": "赤",
    "onyomi": "セキ, シャク",
    "kunyomi": "あか-, あか.い",
    "meaning": "red",
    "bn": "লাল",
    "level": "N5",
    "strokes": 7,
    "examples": [
      {
        "word": "赤い",
        "reading": "あかい",
        "meaning": "red"
      }
    ]
  },
  {
    "kanji": "青",
    "onyomi": "セイ, ショウ",
    "kunyomi": "あお-, あお.い",
    "meaning": "blue, green",
    "bn": "নীল",
    "level": "N5",
    "strokes": 8,
    "examples": [
      {
        "word": "青い",
        "reading": "あおい",
        "meaning": "blue"
      }
    ]
  },
  {
    "kanji": "高",
    "onyomi": "コウ",
    "kunyomi": "たか-, たか.い",
    "meaning": "high, expensive",
    "bn": "উঁচু, দামি",
    "level": "N5",
    "strokes": 10,
    "examples": [
      {
        "word": "高い",
        "reading": "たかい",
        "meaning": "high/expensive"
      }
    ]
  },
  {
    "kanji": "安",
    "onyomi": "アン",
    "kunyomi": "やす-, やす.い",
    "meaning": "cheap, peaceful",
    "bn": "সস্তা",
    "level": "N5",
    "strokes": 6,
    "examples": [
      {
        "word": "安い",
        "reading": "やすい",
        "meaning": "cheap"
      }
    ]
  },
  {
    "kanji": "新",
    "onyomi": "シン",
    "kunyomi": "あたら.しい, あら-",
    "meaning": "new",
    "bn": "নতুন",
    "level": "N5",
    "strokes": 13,
    "examples": [
      {
        "word": "新しい",
        "reading": "あたらしい",
        "meaning": "new"
      }
    ]
  },
  {
    "kanji": "古",
    "onyomi": "コ",
    "kunyomi": "ふる-, ふる.い",
    "meaning": "old",
    "bn": "পুরানো",
    "level": "N5",
    "strokes": 5,
    "examples": [
      {
        "word": "古い",
        "reading": "ふるい",
        "meaning": "old"
      }
    ]
  },
  {
    "kanji": "長",
    "onyomi": "チョウ",
    "kunyomi": "なが-, なが.い",
    "meaning": "long",
    "bn": "লম্বা",
    "level": "N5",
    "strokes": 8,
    "examples": [
      {
        "word": "長い",
        "reading": "ながい",
        "meaning": "long"
      }
    ]
  },
  {
    "kanji": "短",
    "onyomi": "タン",
    "kunyomi": "みじか-, みじか.い",
    "meaning": "short",
    "bn": "খাটো",
    "level": "N5",
    "strokes": 12,
    "examples": [
      {
        "word": "短い",
        "reading": "みじかい",
        "meaning": "short"
      }
    ]
  },
  {
    "kanji": "多",
    "onyomi": "タ",
    "kunyomi": "おお-, おお.い",
    "meaning": "many, much",
    "bn": "অনেক",
    "level": "N5",
    "strokes": 6,
    "examples": [
      {
        "word": "多い",
        "reading": "おおい",
        "meaning": "many"
      }
    ]
  },
  {
    "kanji": "少",
    "onyomi": "ショウ",
    "kunyomi": "すこ-, すく.ない",
    "meaning": "few, little",
    "bn": "কম",
    "level": "N5",
    "strokes": 4,
    "examples": [
      {
        "word": "少ない",
        "reading": "すくない",
        "meaning": "few"
      }
    ]
  },
  {
    "kanji": "良",
    "onyomi": "リョウ",
    "kunyomi": "よ-, い.い",
    "meaning": "good",
    "bn": "ভালো",
    "level": "N5",
    "strokes": 7,
    "examples": [
      {
        "word": "良い",
        "reading": "よい",
        "meaning": "good"
      }
    ]
  },
  {
    "kanji": "悪",
    "onyomi": "アク, オ",
    "kunyomi": "わる-, わる.い",
    "meaning": "bad, evil",
    "bn": "খারাপ",
    "level": "N5",
    "strokes": 11,
    "examples": [
      {
        "word": "悪い",
        "reading": "わるい",
        "meaning": "bad"
      }
    ]
  },
  {
    "kanji": "早",
    "onyomi": "ソウ, サッ",
    "kunyomi": "はや-, はや.い",
    "meaning": "early, fast",
    "bn": "তাড়াতাড়ি",
    "level": "N5",
    "strokes": 6,
    "examples": [
      {
        "word": "早い",
        "reading": "はやい",
        "meaning": "early"
      }
    ]
  },
  {
    "kanji": "遅",
    "onyomi": "チ",
    "kunyomi": "おそ-, おそ.い",
    "meaning": "late, slow",
    "bn": "দেরি",
    "level": "N5",
    "strokes": 12,
    "examples": [
      {
        "word": "遅い",
        "reading": "おそい",
        "meaning": "late/slow"
      }
    ]
  },
  {
    "kanji": "東",
    "onyomi": "トウ",
    "kunyomi": "ひがし",
    "meaning": "east",
    "bn": "পূর্ব",
    "level": "N5",
    "strokes": 8,
    "examples": [
      {
        "word": "東京",
        "reading": "とうきょう",
        "meaning": "Tokyo"
      }
    ]
  },
  {
    "kanji": "西",
    "onyomi": "セイ, サイ",
    "kunyomi": "にし",
    "meaning": "west",
    "bn": "পশ্চিম",
    "level": "N5",
    "strokes": 6,
    "examples": [
      {
        "word": "西口",
        "reading": "にしぐち",
        "meaning": "west exit"
      }
    ]
  },
  {
    "kanji": "南",
    "onyomi": "ナン, ナ",
    "kunyomi": "みなみ",
    "meaning": "south",
    "bn": "দক্ষিণ",
    "level": "N5",
    "strokes": 9,
    "examples": [
      {
        "word": "南口",
        "reading": "みなみぐち",
        "meaning": "south exit"
      }
    ]
  },
  {
    "kanji": "北",
    "onyomi": "ホク",
    "kunyomi": "きた",
    "meaning": "north",
    "bn": "উত্তর",
    "level": "N5",
    "strokes": 5,
    "examples": [
      {
        "word": "北口",
        "reading": "きたぐち",
        "meaning": "north exit"
      }
    ]
  },
  {
    "kanji": "口",
    "onyomi": "コウ, ク",
    "kunyomi": "くち",
    "meaning": "mouth",
    "bn": "মুখ",
    "level": "N5",
    "strokes": 3,
    "examples": [
      {
        "word": "入口",
        "reading": "いりぐち",
        "meaning": "entrance"
      }
    ]
  },
  {
    "kanji": "目",
    "onyomi": "モク, ボク",
    "kunyomi": "め",
    "meaning": "eye",
    "bn": "চোখ",
    "level": "N5",
    "strokes": 5,
    "examples": [
      {
        "word": "目薬",
        "reading": "めぐすり",
        "meaning": "eye drops"
      }
    ]
  },
  {
    "kanji": "耳",
    "onyomi": "ジ",
    "kunyomi": "みみ",
    "meaning": "ear",
    "bn": "কান",
    "level": "N5",
    "strokes": 6,
    "examples": [
      {
        "word": "耳鳴り",
        "reading": "みみなり",
        "meaning": "ear ringing"
      }
    ]
  },
  {
    "kanji": "手",
    "onyomi": "シュ",
    "kunyomi": "て",
    "meaning": "hand",
    "bn": "হাত",
    "level": "N5",
    "strokes": 4,
    "examples": [
      {
        "word": "手紙",
        "reading": "てがみ",
        "meaning": "letter"
      }
    ]
  },
  {
    "kanji": "足",
    "onyomi": "ソク",
    "kunyomi": "あし, た.りる",
    "meaning": "foot, leg",
    "bn": "পা",
    "level": "N5",
    "strokes": 7,
    "examples": [
      {
        "word": "足りる",
        "reading": "たりる",
        "meaning": "to be enough"
      }
    ]
  },
  {
    "kanji": "名",
    "onyomi": "メイ, ミョウ",
    "kunyomi": "な",
    "meaning": "name",
    "bn": "নাম",
    "level": "N5",
    "strokes": 6,
    "examples": [
      {
        "word": "名前",
        "reading": "なまえ",
        "meaning": "name"
      }
    ]
  }
];

export const N4_KANJI_MASSIVE = [
  {
    "kanji": "運",
    "onyomi": "ウン",
    "kunyomi": "はこ.ぶ",
    "meaning": "luck, transport",
    "bn": "ভাগ্য, পরিবহন",
    "level": "N4",
    "strokes": 12,
    "examples": [
      {
        "word": "運動",
        "reading": "うんどう",
        "meaning": "exercise"
      }
    ]
  },
  {
    "kanji": "動",
    "onyomi": "ドウ",
    "kunyomi": "うご.く",
    "meaning": "move",
    "bn": "নড়াচড়া",
    "level": "N4",
    "strokes": 11,
    "examples": [
      {
        "word": "動物",
        "reading": "どうぶつ",
        "meaning": "animal"
      }
    ]
  },
  {
    "kanji": "物",
    "onyomi": "ブツ, モツ",
    "kunyomi": "もの",
    "meaning": "thing",
    "bn": "জিনিস",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "買い物",
        "reading": "かいもの",
        "meaning": "shopping"
      }
    ]
  },
  {
    "kanji": "事",
    "onyomi": "ジ, ズ",
    "kunyomi": "こと",
    "meaning": "thing, matter",
    "bn": "বিষয়",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "仕事",
        "reading": "しごと",
        "meaning": "work"
      }
    ]
  },
  {
    "kanji": "仕",
    "onyomi": "シ, ジ",
    "kunyomi": "つか.える",
    "meaning": "serve, work",
    "bn": "সেবা করা",
    "level": "N4",
    "strokes": 5,
    "examples": [
      {
        "word": "仕事",
        "reading": "しごと",
        "meaning": "work"
      }
    ]
  },
  {
    "kanji": "場",
    "onyomi": "ジョウ",
    "kunyomi": "ば",
    "meaning": "place",
    "bn": "জায়গা",
    "level": "N4",
    "strokes": 12,
    "examples": [
      {
        "word": "場所",
        "reading": "ばしょ",
        "meaning": "place"
      }
    ]
  },
  {
    "kanji": "所",
    "onyomi": "ショ",
    "kunyomi": "ところ",
    "meaning": "place",
    "bn": "স্থান",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "台所",
        "reading": "だいどころ",
        "meaning": "kitchen"
      }
    ]
  },
  {
    "kanji": "住",
    "onyomi": "ジュウ",
    "kunyomi": "す.む",
    "meaning": "live, reside",
    "bn": "বাস করা",
    "level": "N4",
    "strokes": 7,
    "examples": [
      {
        "word": "住所",
        "reading": "じゅうしょ",
        "meaning": "address"
      }
    ]
  },
  {
    "kanji": "使",
    "onyomi": "シ",
    "kunyomi": "つか.う",
    "meaning": "use",
    "bn": "ব্যবহার করা",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "使う",
        "reading": "つかう",
        "meaning": "to use"
      }
    ]
  },
  {
    "kanji": "持",
    "onyomi": "ジ",
    "kunyomi": "も.つ",
    "meaning": "hold, have",
    "bn": "ধরা, থাকা",
    "level": "N4",
    "strokes": 9,
    "examples": [
      {
        "word": "持つ",
        "reading": "もつ",
        "meaning": "to hold"
      }
    ]
  },
  {
    "kanji": "待",
    "onyomi": "タイ",
    "kunyomi": "ま.つ",
    "meaning": "wait",
    "bn": "অপেক্ষা করা",
    "level": "N4",
    "strokes": 9,
    "examples": [
      {
        "word": "待つ",
        "reading": "まつ",
        "meaning": "to wait"
      }
    ]
  },
  {
    "kanji": "送",
    "onyomi": "ソウ",
    "kunyomi": "おく.る",
    "meaning": "send",
    "bn": "পাঠানো",
    "level": "N4",
    "strokes": 9,
    "examples": [
      {
        "word": "送る",
        "reading": "おくる",
        "meaning": "to send"
      }
    ]
  },
  {
    "kanji": "届",
    "onyomi": "トドけ",
    "kunyomi": "とど.く",
    "meaning": "deliver, reach",
    "bn": "পৌঁছানো",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "届く",
        "reading": "とどく",
        "meaning": "to reach"
      }
    ]
  },
  {
    "kanji": "届",
    "onyomi": "",
    "kunyomi": "とど.ける",
    "meaning": "deliver",
    "bn": "বিতরণ",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "届ける",
        "reading": "とどける",
        "meaning": "to deliver"
      }
    ]
  },
  {
    "kanji": "開",
    "onyomi": "カイ",
    "kunyomi": "あ.ける, ひら.く",
    "meaning": "open",
    "bn": "খোলা",
    "level": "N4",
    "strokes": 12,
    "examples": [
      {
        "word": "開く",
        "reading": "あく",
        "meaning": "to open"
      }
    ]
  },
  {
    "kanji": "閉",
    "onyomi": "ヘイ",
    "kunyomi": "と.じる, し.める",
    "meaning": "close",
    "bn": "বন্ধ করা",
    "level": "N4",
    "strokes": 11,
    "examples": [
      {
        "word": "閉める",
        "reading": "しめる",
        "meaning": "to close"
      }
    ]
  },
  {
    "kanji": "始",
    "onyomi": "シ",
    "kunyomi": "はじ.める, はじ.まる",
    "meaning": "begin",
    "bn": "শুরু করা",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "始める",
        "reading": "はじめる",
        "meaning": "to begin"
      }
    ]
  },
  {
    "kanji": "終",
    "onyomi": "シュウ",
    "kunyomi": "お.わる",
    "meaning": "end",
    "bn": "শেষ করা",
    "level": "N4",
    "strokes": 11,
    "examples": [
      {
        "word": "終わる",
        "reading": "おわる",
        "meaning": "to end"
      }
    ]
  },
  {
    "kanji": "返",
    "onyomi": "ヘン",
    "kunyomi": "かえ.す",
    "meaning": "return",
    "bn": "ফেরত দেওয়া",
    "level": "N4",
    "strokes": 7,
    "examples": [
      {
        "word": "返す",
        "reading": "かえす",
        "meaning": "to return"
      }
    ]
  },
  {
    "kanji": "届",
    "onyomi": "",
    "kunyomi": "とど.ける",
    "meaning": "deliver",
    "bn": "পৌঁছে দেওয়া",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "届ける",
        "reading": "とどける",
        "meaning": "to deliver"
      }
    ]
  },
  {
    "kanji": "教",
    "onyomi": "キョウ",
    "kunyomi": "おし.える",
    "meaning": "teach",
    "bn": "শেখানো",
    "level": "N4",
    "strokes": 11,
    "examples": [
      {
        "word": "教える",
        "reading": "おしえる",
        "meaning": "to teach"
      }
    ]
  },
  {
    "kanji": "習",
    "onyomi": "シュウ",
    "kunyomi": "なら.う",
    "meaning": "learn",
    "bn": "শেখা",
    "level": "N4",
    "strokes": 11,
    "examples": [
      {
        "word": "習う",
        "reading": "ならう",
        "meaning": "to learn"
      }
    ]
  },
  {
    "kanji": "働",
    "onyomi": "ドウ",
    "kunyomi": "はたら.く",
    "meaning": "work",
    "bn": "কাজ করা",
    "level": "N4",
    "strokes": 13,
    "examples": [
      {
        "word": "働く",
        "reading": "はたらく",
        "meaning": "to work"
      }
    ]
  },
  {
    "kanji": "走",
    "onyomi": "ソウ",
    "kunyomi": "はし.る",
    "meaning": "run",
    "bn": "দৌড়ানো",
    "level": "N4",
    "strokes": 7,
    "examples": [
      {
        "word": "走る",
        "reading": "はしる",
        "meaning": "to run"
      }
    ]
  },
  {
    "kanji": "歩",
    "onyomi": "ホ",
    "kunyomi": "ある.く",
    "meaning": "walk",
    "bn": "হাঁটা",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "歩く",
        "reading": "あるく",
        "meaning": "to walk"
      }
    ]
  },
  {
    "kanji": "止",
    "onyomi": "シ",
    "kunyomi": "と.まる, や.める",
    "meaning": "stop",
    "bn": "থামা",
    "level": "N4",
    "strokes": 4,
    "examples": [
      {
        "word": "止まる",
        "reading": "とまる",
        "meaning": "to stop"
      }
    ]
  },
  {
    "kanji": "起",
    "onyomi": "キ",
    "kunyomi": "お.きる, お.こす",
    "meaning": "wake, rise",
    "bn": "জাগা",
    "level": "N4",
    "strokes": 10,
    "examples": [
      {
        "word": "起きる",
        "reading": "おきる",
        "meaning": "to wake up"
      }
    ]
  },
  {
    "kanji": "寝",
    "onyomi": "シン",
    "kunyomi": "ね.る",
    "meaning": "sleep",
    "bn": "ঘুমানো",
    "level": "N4",
    "strokes": 13,
    "examples": [
      {
        "word": "寝る",
        "reading": "ねる",
        "meaning": "to sleep"
      }
    ]
  },
  {
    "kanji": "泳",
    "onyomi": "エイ",
    "kunyomi": "およ.ぐ",
    "meaning": "swim",
    "bn": "সাঁতার কাটা",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "泳ぐ",
        "reading": "およぐ",
        "meaning": "to swim"
      }
    ]
  },
  {
    "kanji": "遊",
    "onyomi": "ユウ",
    "kunyomi": "あそ.ぶ",
    "meaning": "play",
    "bn": "খেলা",
    "level": "N4",
    "strokes": 12,
    "examples": [
      {
        "word": "遊ぶ",
        "reading": "あそぶ",
        "meaning": "to play"
      }
    ]
  },
  {
    "kanji": "産",
    "onyomi": "サン",
    "kunyomi": "う.む",
    "meaning": "produce, birth",
    "bn": "উৎপাদন",
    "level": "N4",
    "strokes": 11,
    "examples": [
      {
        "word": "産業",
        "reading": "さんぎょう",
        "meaning": "industry"
      }
    ]
  },
  {
    "kanji": "業",
    "onyomi": "ギョウ, ゴウ",
    "kunyomi": "わざ",
    "meaning": "business",
    "bn": "ব্যবসা",
    "level": "N4",
    "strokes": 13,
    "examples": [
      {
        "word": "授業",
        "reading": "じゅぎょう",
        "meaning": "class/lesson"
      }
    ]
  },
  {
    "kanji": "授",
    "onyomi": "ジュ",
    "kunyomi": "さず.ける",
    "meaning": "grant, teach",
    "bn": "প্রদান করা",
    "level": "N4",
    "strokes": 11,
    "examples": [
      {
        "word": "授業",
        "reading": "じゅぎょう",
        "meaning": "class"
      }
    ]
  },
  {
    "kanji": "質",
    "onyomi": "シツ",
    "kunyomi": "",
    "meaning": "quality",
    "bn": "গুণ",
    "level": "N4",
    "strokes": 15,
    "examples": [
      {
        "word": "質問",
        "reading": "しつもん",
        "meaning": "question"
      }
    ]
  },
  {
    "kanji": "問",
    "onyomi": "モン",
    "kunyomi": "と.う",
    "meaning": "question",
    "bn": "প্রশ্ন",
    "level": "N4",
    "strokes": 11,
    "examples": [
      {
        "word": "問題",
        "reading": "もんだい",
        "meaning": "problem"
      }
    ]
  },
  {
    "kanji": "題",
    "onyomi": "ダイ",
    "kunyomi": "",
    "meaning": "title, topic",
    "bn": "শিরোনাম",
    "level": "N4",
    "strokes": 18,
    "examples": [
      {
        "word": "宿題",
        "reading": "しゅくだい",
        "meaning": "homework"
      }
    ]
  },
  {
    "kanji": "宿",
    "onyomi": "シュク",
    "kunyomi": "やど",
    "meaning": "inn, lodging",
    "bn": "থাকার জায়গা",
    "level": "N4",
    "strokes": 11,
    "examples": [
      {
        "word": "宿題",
        "reading": "しゅくだい",
        "meaning": "homework"
      }
    ]
  },
  {
    "kanji": "試",
    "onyomi": "シ",
    "kunyomi": "こころ.みる, ため.す",
    "meaning": "try, test",
    "bn": "চেষ্টা করা",
    "level": "N4",
    "strokes": 13,
    "examples": [
      {
        "word": "試験",
        "reading": "しけん",
        "meaning": "exam"
      }
    ]
  },
  {
    "kanji": "験",
    "onyomi": "ケン",
    "kunyomi": "",
    "meaning": "test, effect",
    "bn": "পরীক্ষা",
    "level": "N4",
    "strokes": 18,
    "examples": [
      {
        "word": "経験",
        "reading": "けいけん",
        "meaning": "experience"
      }
    ]
  },
  {
    "kanji": "経",
    "onyomi": "ケイ, キョウ",
    "kunyomi": "へ.る",
    "meaning": "pass through",
    "bn": "অতিক্রম করা",
    "level": "N4",
    "strokes": 11,
    "examples": [
      {
        "word": "経済",
        "reading": "けいざい",
        "meaning": "economy"
      }
    ]
  },
  {
    "kanji": "済",
    "onyomi": "サイ",
    "kunyomi": "す.む",
    "meaning": "finish, settle",
    "bn": "সমাপ্ত করা",
    "level": "N4",
    "strokes": 11,
    "examples": [
      {
        "word": "経済",
        "reading": "けいざい",
        "meaning": "economy"
      }
    ]
  },
  {
    "kanji": "医",
    "onyomi": "イ",
    "kunyomi": "",
    "meaning": "medicine, doctor",
    "bn": "চিকিৎসা",
    "level": "N4",
    "strokes": 7,
    "examples": [
      {
        "word": "医者",
        "reading": "いしゃ",
        "meaning": "doctor"
      }
    ]
  },
  {
    "kanji": "者",
    "onyomi": "シャ",
    "kunyomi": "もの",
    "meaning": "person",
    "bn": "ব্যক্তি",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "若者",
        "reading": "わかもの",
        "meaning": "young person"
      }
    ]
  },
  {
    "kanji": "若",
    "onyomi": "ジャク, ニャク",
    "kunyomi": "わか.い",
    "meaning": "young",
    "bn": "তরুণ",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "若い",
        "reading": "わかい",
        "meaning": "young"
      }
    ]
  },
  {
    "kanji": "病",
    "onyomi": "ビョウ",
    "kunyomi": "や.む",
    "meaning": "sick, disease",
    "bn": "অসুস্থ",
    "level": "N4",
    "strokes": 10,
    "examples": [
      {
        "word": "病気",
        "reading": "びょうき",
        "meaning": "illness"
      }
    ]
  },
  {
    "kanji": "院",
    "onyomi": "イン",
    "kunyomi": "",
    "meaning": "institution",
    "bn": "প্রতিষ্ঠান",
    "level": "N4",
    "strokes": 10,
    "examples": [
      {
        "word": "病院",
        "reading": "びょういん",
        "meaning": "hospital"
      }
    ]
  },
  {
    "kanji": "薬",
    "onyomi": "ヤク",
    "kunyomi": "くすり",
    "meaning": "medicine, drug",
    "bn": "ওষুধ",
    "level": "N4",
    "strokes": 16,
    "examples": [
      {
        "word": "薬局",
        "reading": "やっきょく",
        "meaning": "pharmacy"
      }
    ]
  },
  {
    "kanji": "局",
    "onyomi": "キョク",
    "kunyomi": "",
    "meaning": "bureau, office",
    "bn": "অফিস",
    "level": "N4",
    "strokes": 7,
    "examples": [
      {
        "word": "郵便局",
        "reading": "ゆうびんきょく",
        "meaning": "post office"
      }
    ]
  },
  {
    "kanji": "映",
    "onyomi": "エイ",
    "kunyomi": "うつ.す",
    "meaning": "reflect, project",
    "bn": "প্রতিফলন",
    "level": "N4",
    "strokes": 9,
    "examples": [
      {
        "word": "映画",
        "reading": "えいが",
        "meaning": "movie"
      }
    ]
  },
  {
    "kanji": "画",
    "onyomi": "ガ, カク",
    "kunyomi": "",
    "meaning": "picture",
    "bn": "ছবি",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "映画",
        "reading": "えいが",
        "meaning": "movie"
      }
    ]
  },
  {
    "kanji": "音",
    "onyomi": "オン, イン",
    "kunyomi": "おと, ね",
    "meaning": "sound",
    "bn": "শব্দ",
    "level": "N4",
    "strokes": 9,
    "examples": [
      {
        "word": "音楽",
        "reading": "おんがく",
        "meaning": "music"
      }
    ]
  },
  {
    "kanji": "楽",
    "onyomi": "ガク, ラク",
    "kunyomi": "たの.しい",
    "meaning": "music, comfort",
    "bn": "আরাম",
    "level": "N4",
    "strokes": 13,
    "examples": [
      {
        "word": "音楽",
        "reading": "おんがく",
        "meaning": "music"
      }
    ]
  },
  {
    "kanji": "歌",
    "onyomi": "カ",
    "kunyomi": "うた, うた.う",
    "meaning": "song, sing",
    "bn": "গান",
    "level": "N4",
    "strokes": 14,
    "examples": [
      {
        "word": "歌手",
        "reading": "かしゅ",
        "meaning": "singer"
      }
    ]
  },
  {
    "kanji": "写",
    "onyomi": "シャ",
    "kunyomi": "うつ.す",
    "meaning": "copy, photograph",
    "bn": "ছবি তোলা",
    "level": "N4",
    "strokes": 5,
    "examples": [
      {
        "word": "写真",
        "reading": "しゃしん",
        "meaning": "photograph"
      }
    ]
  },
  {
    "kanji": "真",
    "onyomi": "シン",
    "kunyomi": "ま",
    "meaning": "true, reality",
    "bn": "সত্য",
    "level": "N4",
    "strokes": 10,
    "examples": [
      {
        "word": "写真",
        "reading": "しゃしん",
        "meaning": "photo"
      }
    ]
  },
  {
    "kanji": "絵",
    "onyomi": "カイ, エ",
    "kunyomi": "",
    "meaning": "picture, painting",
    "bn": "ছবি",
    "level": "N4",
    "strokes": 12,
    "examples": [
      {
        "word": "絵",
        "reading": "え",
        "meaning": "picture"
      }
    ]
  },
  {
    "kanji": "紙",
    "onyomi": "シ",
    "kunyomi": "かみ",
    "meaning": "paper",
    "bn": "কাগজ",
    "level": "N4",
    "strokes": 10,
    "examples": [
      {
        "word": "手紙",
        "reading": "てがみ",
        "meaning": "letter"
      }
    ]
  },
  {
    "kanji": "文",
    "onyomi": "ブン, モン",
    "kunyomi": "ふみ",
    "meaning": "sentence, writing",
    "bn": "বাক্য",
    "level": "N4",
    "strokes": 4,
    "examples": [
      {
        "word": "文章",
        "reading": "ぶんしょう",
        "meaning": "sentence"
      }
    ]
  },
  {
    "kanji": "字",
    "onyomi": "ジ",
    "kunyomi": "あざ",
    "meaning": "character, letter",
    "bn": "অক্ষর",
    "level": "N4",
    "strokes": 6,
    "examples": [
      {
        "word": "漢字",
        "reading": "かんじ",
        "meaning": "kanji"
      }
    ]
  },
  {
    "kanji": "漢",
    "onyomi": "カン",
    "kunyomi": "",
    "meaning": "China, Han",
    "bn": "চীন",
    "level": "N4",
    "strokes": 13,
    "examples": [
      {
        "word": "漢字",
        "reading": "かんじ",
        "meaning": "kanji"
      }
    ]
  },
  {
    "kanji": "研",
    "onyomi": "ケン",
    "kunyomi": "と.ぐ",
    "meaning": "research, polish",
    "bn": "গবেষণা",
    "level": "N4",
    "strokes": 9,
    "examples": [
      {
        "word": "研究",
        "reading": "けんきゅう",
        "meaning": "research"
      }
    ]
  },
  {
    "kanji": "究",
    "onyomi": "キュウ",
    "kunyomi": "きわ.める",
    "meaning": "research, study",
    "bn": "অধ্যয়ন",
    "level": "N4",
    "strokes": 7,
    "examples": [
      {
        "word": "研究",
        "reading": "けんきゅう",
        "meaning": "research"
      }
    ]
  },
  {
    "kanji": "特",
    "onyomi": "トク",
    "kunyomi": "",
    "meaning": "special",
    "bn": "বিশেষ",
    "level": "N4",
    "strokes": 10,
    "examples": [
      {
        "word": "特別",
        "reading": "とくべつ",
        "meaning": "special"
      }
    ]
  },
  {
    "kanji": "別",
    "onyomi": "ベツ",
    "kunyomi": "わか.れる",
    "meaning": "separate, another",
    "bn": "আলাদা",
    "level": "N4",
    "strokes": 7,
    "examples": [
      {
        "word": "特別",
        "reading": "とくべつ",
        "meaning": "special"
      }
    ]
  },
  {
    "kanji": "親",
    "onyomi": "シン",
    "kunyomi": "おや, した.しい",
    "meaning": "parent, intimate",
    "bn": "পিতামাতা",
    "level": "N4",
    "strokes": 16,
    "examples": [
      {
        "word": "両親",
        "reading": "りょうしん",
        "meaning": "parents"
      }
    ]
  },
  {
    "kanji": "両",
    "onyomi": "リョウ",
    "kunyomi": "",
    "meaning": "both",
    "bn": "উভয়",
    "level": "N4",
    "strokes": 6,
    "examples": [
      {
        "word": "両方",
        "reading": "りょうほう",
        "meaning": "both sides"
      }
    ]
  },
  {
    "kanji": "兄",
    "onyomi": "キョウ, ケイ",
    "kunyomi": "あに",
    "meaning": "elder brother",
    "bn": "বড় ভাই",
    "level": "N4",
    "strokes": 5,
    "examples": [
      {
        "word": "お兄さん",
        "reading": "おにいさん",
        "meaning": "older brother"
      }
    ]
  },
  {
    "kanji": "弟",
    "onyomi": "テイ, ダイ",
    "kunyomi": "おとうと",
    "meaning": "younger brother",
    "bn": "ছোট ভাই",
    "level": "N4",
    "strokes": 7,
    "examples": [
      {
        "word": "弟",
        "reading": "おとうと",
        "meaning": "younger brother"
      }
    ]
  },
  {
    "kanji": "姉",
    "onyomi": "シ",
    "kunyomi": "あね",
    "meaning": "elder sister",
    "bn": "বড় বোন",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "お姉さん",
        "reading": "おねえさん",
        "meaning": "older sister"
      }
    ]
  },
  {
    "kanji": "妹",
    "onyomi": "マイ",
    "kunyomi": "いもうと",
    "meaning": "younger sister",
    "bn": "ছোট বোন",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "妹",
        "reading": "いもうと",
        "meaning": "younger sister"
      }
    ]
  },
  {
    "kanji": "主",
    "onyomi": "シュ",
    "kunyomi": "ぬし, おも",
    "meaning": "main, master",
    "bn": "প্রধান",
    "level": "N4",
    "strokes": 5,
    "examples": [
      {
        "word": "主人",
        "reading": "しゅじん",
        "meaning": "husband/master"
      }
    ]
  },
  {
    "kanji": "夫",
    "onyomi": "フウ, フ",
    "kunyomi": "おっと",
    "meaning": "husband",
    "bn": "স্বামী",
    "level": "N4",
    "strokes": 4,
    "examples": [
      {
        "word": "夫婦",
        "reading": "ふうふ",
        "meaning": "married couple"
      }
    ]
  },
  {
    "kanji": "婦",
    "onyomi": "フ",
    "kunyomi": "",
    "meaning": "wife, woman",
    "bn": "স্ত্রী",
    "level": "N4",
    "strokes": 11,
    "examples": [
      {
        "word": "主婦",
        "reading": "しゅふ",
        "meaning": "housewife"
      }
    ]
  },
  {
    "kanji": "度",
    "onyomi": "ド",
    "kunyomi": "たび",
    "meaning": "degree, times",
    "bn": "ডিগ্রি",
    "level": "N4",
    "strokes": 9,
    "examples": [
      {
        "word": "温度",
        "reading": "おんど",
        "meaning": "temperature"
      }
    ]
  },
  {
    "kanji": "回",
    "onyomi": "カイ",
    "kunyomi": "まわ.る",
    "meaning": "times, rotate",
    "bn": "বার",
    "level": "N4",
    "strokes": 6,
    "examples": [
      {
        "word": "今回",
        "reading": "こんかい",
        "meaning": "this time"
      }
    ]
  },
  {
    "kanji": "番",
    "onyomi": "バン",
    "kunyomi": "",
    "meaning": "number, turn",
    "bn": "নম্বর",
    "level": "N4",
    "strokes": 12,
    "examples": [
      {
        "word": "番号",
        "reading": "ばんごう",
        "meaning": "number"
      }
    ]
  },
  {
    "kanji": "号",
    "onyomi": "ゴウ",
    "kunyomi": "",
    "meaning": "number",
    "bn": "সংখ্যা",
    "level": "N4",
    "strokes": 5,
    "examples": [
      {
        "word": "番号",
        "reading": "ばんごう",
        "meaning": "number"
      }
    ]
  },
  {
    "kanji": "室",
    "onyomi": "シツ",
    "kunyomi": "むろ",
    "meaning": "room",
    "bn": "ঘর",
    "level": "N4",
    "strokes": 9,
    "examples": [
      {
        "word": "教室",
        "reading": "きょうしつ",
        "meaning": "classroom"
      }
    ]
  },
  {
    "kanji": "堂",
    "onyomi": "ドウ",
    "kunyomi": "",
    "meaning": "hall, temple",
    "bn": "হল",
    "level": "N4",
    "strokes": 11,
    "examples": [
      {
        "word": "食堂",
        "reading": "しょくどう",
        "meaning": "cafeteria"
      }
    ]
  },
  {
    "kanji": "館",
    "onyomi": "カン",
    "kunyomi": "やかた",
    "meaning": "building, hall",
    "bn": "ভবন",
    "level": "N4",
    "strokes": 16,
    "examples": [
      {
        "word": "図書館",
        "reading": "としょかん",
        "meaning": "library"
      }
    ]
  },
  {
    "kanji": "図",
    "onyomi": "ズ, ト",
    "kunyomi": "はか.る",
    "meaning": "diagram, plan",
    "bn": "চিত্র",
    "level": "N4",
    "strokes": 7,
    "examples": [
      {
        "word": "図書館",
        "reading": "としょかん",
        "meaning": "library"
      }
    ]
  },
  {
    "kanji": "公",
    "onyomi": "コウ",
    "kunyomi": "おおやけ",
    "meaning": "public",
    "bn": "সর্বজনীন",
    "level": "N4",
    "strokes": 4,
    "examples": [
      {
        "word": "公園",
        "reading": "こうえん",
        "meaning": "park"
      }
    ]
  },
  {
    "kanji": "園",
    "onyomi": "エン",
    "kunyomi": "その",
    "meaning": "garden, park",
    "bn": "বাগান",
    "level": "N4",
    "strokes": 13,
    "examples": [
      {
        "word": "公園",
        "reading": "こうえん",
        "meaning": "park"
      }
    ]
  },
  {
    "kanji": "地",
    "onyomi": "チ, ジ",
    "kunyomi": "",
    "meaning": "ground, earth",
    "bn": "ভূমি",
    "level": "N4",
    "strokes": 6,
    "examples": [
      {
        "word": "地下鉄",
        "reading": "ちかてつ",
        "meaning": "subway"
      }
    ]
  },
  {
    "kanji": "鉄",
    "onyomi": "テツ",
    "kunyomi": "",
    "meaning": "iron",
    "bn": "লোহা",
    "level": "N4",
    "strokes": 13,
    "examples": [
      {
        "word": "地下鉄",
        "reading": "ちかてつ",
        "meaning": "subway"
      }
    ]
  },
  {
    "kanji": "道",
    "onyomi": "ドウ",
    "kunyomi": "みち",
    "meaning": "road, way",
    "bn": "রাস্তা",
    "level": "N4",
    "strokes": 12,
    "examples": [
      {
        "word": "道路",
        "reading": "どうろ",
        "meaning": "road"
      }
    ]
  },
  {
    "kanji": "路",
    "onyomi": "ロ",
    "kunyomi": "じ",
    "meaning": "road, path",
    "bn": "পথ",
    "level": "N4",
    "strokes": 13,
    "examples": [
      {
        "word": "道路",
        "reading": "どうろ",
        "meaning": "road"
      }
    ]
  },
  {
    "kanji": "通",
    "onyomi": "ツウ",
    "kunyomi": "とお.る, かよ.う",
    "meaning": "pass through",
    "bn": "অতিক্রম",
    "level": "N4",
    "strokes": 10,
    "examples": [
      {
        "word": "通う",
        "reading": "かよう",
        "meaning": "to commute"
      }
    ]
  },
  {
    "kanji": "乗",
    "onyomi": "ジョウ",
    "kunyomi": "の.る",
    "meaning": "ride",
    "bn": "চড়া",
    "level": "N4",
    "strokes": 9,
    "examples": [
      {
        "word": "乗る",
        "reading": "のる",
        "meaning": "to ride"
      }
    ]
  },
  {
    "kanji": "降",
    "onyomi": "コウ",
    "kunyomi": "お.りる, ふ.る",
    "meaning": "descend, fall",
    "bn": "নামা",
    "level": "N4",
    "strokes": 10,
    "examples": [
      {
        "word": "降りる",
        "reading": "おりる",
        "meaning": "to get off"
      }
    ]
  },
  {
    "kanji": "届",
    "onyomi": "",
    "kunyomi": "とど.く, とど.ける",
    "meaning": "deliver",
    "bn": "পৌঁছানো",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "届く",
        "reading": "とどく",
        "meaning": "to reach"
      }
    ]
  },
  {
    "kanji": "届",
    "onyomi": "",
    "kunyomi": "とど.く",
    "meaning": "deliver, reach",
    "bn": "পৌঁছানো",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "届け",
        "reading": "とどけ",
        "meaning": "delivery"
      }
    ]
  },
  {
    "kanji": "届",
    "onyomi": "",
    "kunyomi": "とど.ける",
    "meaning": "reach",
    "bn": "পৌঁছানো",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "届ける",
        "reading": "とどける",
        "meaning": "to deliver"
      }
    ]
  },
  {
    "kanji": "届",
    "onyomi": "",
    "kunyomi": "とど.く",
    "meaning": "deliver",
    "bn": "পাঠানো",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "届く",
        "reading": "とどく",
        "meaning": "to arrive"
      }
    ]
  },
  {
    "kanji": "届",
    "onyomi": "",
    "kunyomi": "とど.く",
    "meaning": "reach, arrive",
    "bn": "পৌঁছে যাওয়া",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "届く",
        "reading": "とどく",
        "meaning": "to be delivered"
      }
    ]
  },
  {
    "kanji": "届",
    "onyomi": "",
    "kunyomi": "とど.ける",
    "meaning": "deliver, send",
    "bn": "বিতরণ করা",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "届ける",
        "reading": "とどける",
        "meaning": "to deliver"
      }
    ]
  },
  {
    "kanji": "届",
    "onyomi": "",
    "kunyomi": "とど.け",
    "meaning": "notice",
    "bn": "নোটিশ",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "届け出",
        "reading": "とどけで",
        "meaning": "report/notification"
      }
    ]
  },
  {
    "kanji": "届",
    "onyomi": "",
    "kunyomi": "とど.ける",
    "meaning": "report",
    "bn": "রিপোর্ট",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "届け出る",
        "reading": "とどけでる",
        "meaning": "to report"
      }
    ]
  },
  {
    "kanji": "届",
    "onyomi": "",
    "kunyomi": "とど.ける",
    "meaning": "deliver",
    "bn": "পৌঁছে দেওয়া",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "届ける",
        "reading": "とどける",
        "meaning": "to send"
      }
    ]
  },
  {
    "kanji": "届",
    "onyomi": "",
    "kunyomi": "とど.く, とど.ける",
    "meaning": "reach, deliver",
    "bn": "পৌঁছানো",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "届く",
        "reading": "とどく",
        "meaning": "to arrive"
      }
    ]
  },
  {
    "kanji": "届",
    "onyomi": "",
    "kunyomi": "とど.く",
    "meaning": "arrive",
    "bn": "আসা",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "届く",
        "reading": "とどく",
        "meaning": "to reach"
      }
    ]
  },
  {
    "kanji": "届",
    "onyomi": "",
    "kunyomi": "とど.ける",
    "meaning": "send",
    "bn": "পাঠানো",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "届ける",
        "reading": "とどける",
        "meaning": "to deliver"
      }
    ]
  },
  {
    "kanji": "届",
    "onyomi": "",
    "kunyomi": "とど.く",
    "meaning": "deliver, notification",
    "bn": "বিজ্ঞপ্তি",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "届",
        "reading": "とどけ",
        "meaning": "report"
      }
    ]
  },
  {
    "kanji": "届",
    "onyomi": "",
    "kunyomi": "とど.く",
    "meaning": "reach",
    "bn": "পৌঁছানো",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "届く",
        "reading": "とどく",
        "meaning": "to arrive at"
      }
    ]
  },
  {
    "kanji": "届",
    "onyomi": "",
    "kunyomi": "とど.ける",
    "meaning": "deliver",
    "bn": "ডেলিভারি",
    "level": "N4",
    "strokes": 8,
    "examples": [
      {
        "word": "届ける",
        "reading": "とどける",
        "meaning": "to deliver"
      }
    ]
  }
];